import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from '../molecules';
import { PopularCourseCard } from '../molecules';

const PopularCoursesSection = ({ className = "" }) => {
  const { t } = useTranslation();

  const courses = [
    {
      title: "หลักสูตรท่องเที่ยวโตเกียวระดับพรีเมียม",
      duration: "8 ชั่วโมง",
      price: "120,000 เยน～",
      description: "คอร์สยอดนิยมอันดับ 1 ของเรา ครอบคลุมสถานที่ท่องเที่ยวที่เป็นตัวแทนของโตเกียวได้อย่างมีประสิทธิภาพ เพลิดเพลินไปกับเสน่ห์ของโตเกียวที่ประเพณีและความทันสมัยผสมผสานกัน",
      spots: [
        "อาซากุสะและประตูคามินาริมอน",
        "สวนพระราชวังอิมพีเรียลอีสต์",
        "ช้อปปิ้งที่กินซ่า",
        "โตเกียวสกายทรี"
      ]
    },
    {
      title: "เส้นทางชมวิวภูเขาฟูจิและฮาโกเน่",
      duration: "10 ชั่วโมง",
      price: "150,000 เยน～",
      description: "หลักสูตรเพื่อเพลิดเพลินกับธรรมชาติอันงดงามของภูเขาฟูจิและฮาโกเน่ ซึ่งเป็นสัญลักษณ์ของญี่ปุ่น โอกาสในการถ่ายภาพ ณ จุดชมวิวและการผ่อนคลายที่บ่อน้ำร้อนเป็นที่นิยม",
      spots: [
        "ทะเลสาบทั้งห้าของฟูจิ",
        "ศาลเจ้าฮาโกเน่",
        "ล่องเรือทะเลสาบอาชิ",
        "ประสบการณ์ออนเซ็น"
      ]
    },
    {
      title: "คอร์สประวัติศาสตร์คามาคุระและเอโนชิมะ",
      duration: "6 ชั่วโมง",
      price: "90,000 เยน～",
      description: "หลักสูตรพิเศษเพื่อสัมผัสประวัติศาสตร์และวัฒนธรรมของคามาคุระโบราณ เพลิดเพลินกับวัดอายุ 800 ปีและชายฝั่งทะเลที่สวยงาม",
      spots: [
        "ศาลเจ้าทสึรุกาโอกะฮาจิมังกู",
        "พระใหญ่",
        "หอสังเกตการณ์เอโนชิมะ",
        "คาเฟ่ในบ้านแบบดั้งเดิม"
      ]
    }
  ];

  return (
    <section className={`py-16 bg-white ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          badge="ทัวร์ยอดนิยม"
          title="แนะนำคอร์สท่องเที่ยวยอดนิยมของลูกค้า"
          subtitle="หลักสูตรทั้งหมดสามารถปรับแต่งได้"
          className="text-center mb-12"
        />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <PopularCourseCard
              key={index}
              course={course}
              className="h-full"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularCoursesSection;
